import { render } from "./multiselect.vue?vue&type=template&id=6b6ca78a&scoped=true"
import script from "./multiselect.vue?vue&type=script&lang=js"
export * from "./multiselect.vue?vue&type=script&lang=js"

import "./multiselect.vue?vue&type=style&index=0&id=6b6ca78a&scoped=true&lang=css"
import "./multiselect.vue?vue&type=style&index=1&id=6b6ca78a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b6ca78a"]])

export default __exports__